const testimonials = [
  {
    name: 'Анна К.',
    handle: '@anna_style_msk',
    text: 'YOYBUY Spreadsheet полностью изменил мой подход к шоппингу! Раньше я боялась заказывать из Китая, а теперь это так же просто, как заполнить таблицу. Качество вещей отличное, доставка быстрая. Очень рекомендую всем, кто хочет покупать модные вещи по доступным ценам.',
    bg: 'bg-accent-100',
  },
  {
    name: 'Дмитрий В.',
    handle: '@dmitry_shop_spb',
    text: 'Перепробовал и Kakobuy, и Superbuy — YOYBUY Spreadsheet оказался самым удобным. Низкие комиссии, понятная система, отличная поддержка на русском языке. Теперь это мой основной инструмент для заказов из Китая.',
    bg: 'bg-secondary-100',
  },
  {
    name: 'Елена М.',
    handle: '@elena_fashion_kzn',
    text: 'Я профессионально занимаюсь ресейлом брендовой одежды, и YOYBUY Spreadsheet — это мой секретный инструмент. Таблица позволяет очень удобно отслеживать десятки заказов одновременно и контролировать бюджет.',
    bg: 'bg-primary-100',
  },
  {
    name: 'Сергей П.',
    handle: '@sergey_buyer_nsk',
    text: 'Использую YOYBUY Spreadsheet уже полгода. За это время сделал больше 50 заказов — ни одной проблемы! Таблица реально удобнее любого приложения. Всё прозрачно, все цены видны сразу.',
    bg: 'bg-accent-100',
  },
  {
    name: 'Ольга Р.',
    handle: '@olga_style_ekb',
    text: 'Долго искала простой способ заказывать вещи с Taobao, и YOYBUY Spreadsheet стал идеальным решением. Очень нравится, что можно просто вставить ссылку в таблицу и забыть — всё остальное делают за тебя.',
    bg: 'bg-secondary-100',
  },
  {
    name: 'Алексей Т.',
    handle: '@alexey_shop_vld',
    text: 'Что меня поразило в YOYBUY Spreadsheet — это скорость обработки заказов. В Kakobuy иногда ждал по несколько дней, а здесь всё обрабатывается буквально за часы. И цены реально ниже. Лучший выбор для шоппинга из Китая!',
    bg: 'bg-primary-100',
  },
];

export default function Testimonials() {
  return (
    <section className="bg-background-100/80 py-20 md:py-24 px-4 md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200/60 text-foreground-400 text-xs font-label font-medium tracking-wide uppercase">
            Отзывы
          </span>
          <h2 className="mt-4 text-3xl md:text-[48px] font-heading font-bold text-foreground-950 leading-tight">
            Отзывы пользователей
            <br />
            <span className="italic font-medium text-foreground-700">О шоппинге с YOYBUY</span>
          </h2>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5">
          {testimonials.map((t) => (
            <div
              key={t.handle}
              className="break-inside-avoid p-6 rounded-2xl bg-white border border-foreground-100/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-10 h-10 rounded-full ${t.bg} flex items-center justify-center`}>
                  <span className="text-sm font-semibold text-foreground-700">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.handle}</p>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                «{t.text}»
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}